export const formatPlanCategory = payerPlan => {
  if (!payerPlan) return 'Unknown';
  switch (payerPlan.category) {
    case 'COMMERCIAL':
      return 'Commercial';
    case 'AUTO':
      return 'Auto';
    case 'WORK_COMP':
      return 'Workers Comp';
    case 'LIEN':
      return 'Lien';
    default:
      return 'Unknown';
  }
};